import React, { useState } from "react";
import axios from "axios";
import config from "../../../config";
import {
  Box,
  Typography,
  Button,
  CircularProgress
} from "@mui/material";
import GenericTable from "../../../components/AdminDashboard/GenericTable/GenericTable";

const jobs = [
    { id: "availability_sync", name: "Availability Sync", description: "Scrapes product URLs for all active stores to sync their current availability status." },
    { id: "authorize_reconciliation", name: "Authorize.net Reconciliation", description: "Processes daily renewals, handles failed payments, and manages 3-day grace periods." }
];

const BatchJobs = () => {
  const [loading, setLoading] = useState({});
  const [message, setMessage] = useState({ text: "", type: "" });

  const handleTrigger = async (jobId) => {
    setLoading(prev => ({ ...prev, [jobId]: true }));
    setMessage({ text: "", type: "" });
    
    try {
      const url = `${config.CLIENT_API_BASE_URL}/admin-jobs/trigger/${jobId}`;
      const res = await axios.post(url, {}, { 
          headers: { "x-admin-secret": config.CRON_SECRET } 
      });
      setMessage({ type: "success", text: res.data.message || `Job triggered successfully.` });
    } catch (err) {
      const errorMsg = err.response?.data?.detail || err.response?.data?.error || err.message;
      if (err.response && err.response.status === 202) {
         setMessage({ type: "success", text: `Job triggered successfully in the background.` });
      } else {
         setMessage({ type: "error", text: `Failed to trigger job: ${errorMsg}` });
      }
    } finally {
      setLoading(prev => ({ ...prev, [jobId]: false }));
    }
  };

  const jobColumns = [
      { 
          id: "job_name", 
          label: "Job Name", 
          render: (row) => (
              <div>
                  <strong>{row.name}</strong><br/>
                  <small style={{ color: "#64748b", fontFamily: "monospace" }}>{row.id}</small>
              </div>
          ) 
      },
      { 
          id: "description", 
          label: "Description", 
          render: (row) => row.description 
      },
      { 
          id: "action", 
          label: "Action", 
          render: (row) => (
              <Button
                  variant="contained"
                  size="small"
                  disabled={loading[row.id]}
                  onClick={() => handleTrigger(row.id)}
                  sx={{ 
                      textTransform: "none", 
                      backgroundColor: "#1976d2", 
                      fontWeight: 600,
                      "&:hover": { backgroundColor: "#1565c0" }
                  }}
              >
                  {loading[row.id] ? "Starting..." : "Trigger Now"}
              </Button>
          ) 
      }
  ];

  return (
    <div style={{ padding: "0" }}>
        <Box sx={{ px: 4, pt: 4, pb: 1 }}>
            <Typography variant="h4" sx={{ fontWeight: 800, color: "#0f172a", mb: 1, letterSpacing: "-0.5px" }}>
                Batch Jobs Configuration
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 2, maxWidth: "800px" }}>
                Trigger background sync processes and reconciliation workflows on-demand.
            </Typography>
        </Box>

        <Box sx={{ p: 4, pt: 0 }}>
            {/* Minimal Top Bar matching Gateway Logs */}
            <Box sx={{ 
                mb: 0, 
                p: 2, 
                backgroundColor: "#ffffff", 
                borderRadius: "8px 8px 0 0", 
                display: "flex", 
                gap: 2, 
                flexWrap: "wrap", 
                alignItems: "center",
                border: "1px solid #e0e0e0", 
                borderBottom: "none" 
            }}>
                <Box sx={{ flexGrow: 1 }}>
                     {message.text && (
                        <Typography 
                            variant="body2" 
                            sx={{ color: message.type === 'error' ? '#d32f2f' : '#2e7d32', fontWeight: 600 }}
                        >
                            {message.type === 'error' ? '❌ ' : '✅ '}{message.text}
                        </Typography>
                     )}
                </Box>
            </Box>

            <GenericTable
                title=""
                columns={jobColumns}
                rows={jobs}
                isServerSide={false}
                hideExport={true}
                showView={false}
            />
        </Box>
    </div>
  );
};

export default BatchJobs;
